<template>
  <el-dialog title="选择活动" :visible="true" width="1000px" center @close="dialogClose">
    <!-- 导航切换 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="item.name" :name="`index${index}`" v-for="(item, index) in navList" :key="item.id"></el-tab-pane>
    </el-tabs>
    <!-- 头部表单查询 -->
    <input-form ref="inputForm12" :btnPosition1="true" :defaultSelectArr="true" :inputData="inputData" @toParentVal="searchForm"></input-form>
    <!-- 表格内容 -->
    <el-table
      :data="activityList"
      v-loading="talbeLoading"
      style="width: 100%; margin-top: 20px"
      ref="table"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <template slot="empty">
        <div>
          <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column :label="activeName == 'index5' ? '礼品名称' : '活动名称'" prop="activityName"> </el-table-column>
      <el-table-column :label="activeName == 'index5' ? '礼品类型' : '活动类型'">
        <template slot-scope="scope">
          <span v-if="scope.row.activityType == 1"> 日历签到 </span>
          <span v-if="scope.row.activityType == 2"> 浏览礼品有礼 </span>
          <span v-if="scope.row.activityType == 3"> 每日抢好礼 </span>
          <span v-if="scope.row.activityType == 4"> 关注店铺有礼 </span>
          <span v-if="scope.row.activityType == 5"> 邀请开卡 </span>
          <span v-if="scope.row.activityType == 6"> 邀请关注店铺 </span>
          <span v-if="scope.row.activityType == 7"> 完善信息有礼 </span>
          <span v-if="scope.row.activityType == 8"> 幸运抽奖 </span>
          <span v-if="scope.row.activityType == 9">兑换实物</span>
          <span v-if="scope.row.activityType == 10">兑换优惠券</span>
          <span v-if="scope.row.type == 11">新人优惠券</span>
          <span v-if="scope.row.type == 12">会员优惠券</span>
          <span v-if="scope.row.activityType == 13">开卡礼包</span>
          <span v-if="scope.row.activityType == 14">店铺礼包</span>
          <span v-if="scope.row.activityType == 15">店铺礼包（千人千面）</span>
          <span v-if="scope.row.activityType == 16">下单有礼</span>
          <span v-if="scope.row.activityType == 17">首单专享礼</span>
          <span v-if="scope.row.activityType == 18">复购有礼</span>
          <span v-if="scope.row.activityType == 19">下单抽奖</span>
          <span v-if="scope.row.activityType == 20">评价有礼</span>
          <span v-if="scope.row.activityType == 21">裂变神券</span>
          <span v-if="scope.row.activityType == 22">天降红包雨</span>
          <span v-if="scope.row.activityType == 23">疯狂捉娃娃</span>
          <span v-if="scope.row.activityType == 24">大家来找茬</span>
          <span v-if="scope.row.activityType == 31">超级裂变权</span>
          <span v-if="scope.row.activityType == 34">加购有礼</span>
          <span v-if="scope.row.activityType == 36">下单冲榜</span>
        </template>
      </el-table-column>
      <el-table-column :label="activeName == 'index5' ? '上下架时间' : '活动时间'">
        <template slot-scope="scope">
          <div class="activityTime" v-if="activeName == 'index5'">
            <span>上架: {{ scope.row.startTime }}</span
            ><br />
            <span>下架: {{ scope.row.endTime }}</span>
          </div>
          <div v-else-if="activeName == 'index6'">
            起:<span>{{ scope.row.couponStartTime }}</span
            ><br />
            止:<span>{{ scope.row.couponEndTime }}</span>
          </div>
          <div class="activityTime" v-else>
            <span>起: {{ scope.row.startTime }}</span
            ><br />
            <span>止: {{ scope.row.endTime }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="活动状态">
        <template slot-scope="scope">
          <div v-if="activeName == 'index5'">
            <span v-if="scope.row.status == 1"> <i class="y1"></i>待上架 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>已上架 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已下架 </span>
          </div>
          <div v-else-if="activeName == 'index6'">
            <span v-if="scope.row.status == 2"> <i class="y1"></i>未开始 </span>
            <span v-if="scope.row.status == 1"> <i class="y2"></i>进行中 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已结束 </span>
          </div>
          <div v-else>
            <span v-if="scope.row.status == 1"> <i class="y1"></i>未开始 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>进行中 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已结束 </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div class="editList">
            <span
              v-if="scope.row.status != 3 || scope.row.activityType == 13 || scope.row.activityType == 14 || scope.row.activityType == 15"
              style="color:#7B61FF"
              class="pointer"
              @click="handleSave(scope.row)"
            >
              选择
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="recordData.current"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="recordData.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="recordData.total"
      class="pagination"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "@/components/inputForm";
import { queryActivity } from "@/api/activityController";
import { exchangeActivityList } from "@/api/paradiseAndTaskCommonController.js";
import { queryPage } from "@/api/integralCenter/benefitActivityController";
export default {
  components: {
    inputForm,
  },
  data() {
    return {
      activeName: "index0",
      navList: [
        {
          name: "日常玩法",
          id: 1,
        },
        {
          name: "无线营销",
          id: 2,
        },
        {
          name: "裂变营销",
          id: 3,
        },
        {
          name: "趣味抽奖",
          id: 4,
        },
        {
          name: "游戏中心",
          id: 5,
        },
        {
          name: "会员商城",
          id: 6,
        },
        {
          name: "会员权益",
          id: 7,
        },
      ],
      activityList: [],
      talbeLoading: false,
      recordData: {
        size: 10,
        current: 1,
        total: 0,
        status: 1,
      },
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
          width: "150px",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          width: "150px",
          selectArr: [
            // { label: "全部", id: null, defaultValue: 1 },
            { label: "未开始", id: 1, defaultValue: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      mainType: 1,
    };
  },
  mounted() {
    this.getPolite();
  },
  methods: {
    // handleNav(item, index) {
    //   this.tabActive = index;
    //   this.navItem = item;
    //   this.getPolite();
    // },
    handleClick(tab) {
      this.recordData = {
        size: 10,
        current: 1,
        total: 0,
        status: 1,
      };
      console.log(tab);
      if (tab.index == 0 || tab.index == 1 || tab.index == 2 || tab.index == 3 || tab.index == 4) {
        this.inputData.splice(
          0,
          2,
          {
            name: "活动名称:",
            val: "activityName",
            placeholder: "请输入活动名称",
            width: "150px",
          },
          {
            name: "活动状态:",
            val: "status",
            placeholder: "请选择",
            width: "150px",
            selectArr: [
              // { label: "全部", id: null, defaultValue: 1 },
              { label: "未开始", id: 1, defaultValue: 1 },
              { label: "进行中", id: 2 },
              { label: "已结束", id: 3 },
            ],
          }
        );
      }
      this.mainType = tab.index * 1 + 1;
      // if (tab.index == 1) this.mainType = 1;
      // if (tab.index == 3) this.mainType = 3;
      if (tab.index == 5) {
        this.inputData.splice(
          0,
          2,
          {
            name: "活动名称：",
            val: "activityName",
            placeholder: "请输入活动名称",
          },
          {
            name: "上架状态",
            val: "status",
            selectArr: [
              // { label: "全部", id: null, defaultValue: 1 },
              { label: "待上架", id: 1, defaultValue: 1 },
              { label: "已上架", id: 2 },
              { label: "已下架", id: 3 },
            ],
          }
        );
      }
      console.log(tab.index, 222);
      if (tab.index == 6) {
        this.recordData = {
          size: 10,
          current: 1,
          total: 0,
          status: 2,
        };
        this.inputData.splice(
          0,
          2,
          {
            name: "活动名称:",
            val: "username",
            placeholder: "请输入活动名称",
          },
          {
            name: "活动状态:",
            val: "status",
            selectArr: [
              // { label: "全部", id: null },
              { label: "未开始", id: 2, defaultValue: 2 },
              { label: "进行中", id: 1 },
              { label: "已结束", id: 3 },
            ],
          }
        );
      }
      this.$refs.inputForm12.initVal();
      this.getPolite();
    },
    handleSave(val) {
      if (val.activityType == 13 || val.activityType == 14 || val.activityType == 15) {
        return this.$message.warning("不能选择礼包类型活动");
      }
      this.$emit("handleClose", val);
    },
    dialogClose() {
      this.$emit("handleClose");
    },
    // 表单查询
    searchForm(form) {
      console.log(form, 123564);
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName || "";
      this.recordData.status = form.status;
      this.recordData.username = form.username || "";
      this.getPolite();
    },
    async getPolite() {
      let params = {
        current: this.recordData.current,
        size: this.recordData.size,
        activityName: this.recordData.activityName,
        status: this.recordData.status,
        activityNewMainTypes: this.mainType,
        username: this.recordData.username,
      };

      let res = {};

      // 商城
      if (this.activeName == "index5") {
        res = await exchangeActivityList(params);
      } else if (this.activeName == "index6") {
        // 会员权益
        res = await queryPage(params);
      } else {
        //
        res = await queryActivity(params);
      }
      this.activityList = res.data.records ? this.activityUrl(res.data.records) : [];
      this.recordData.total = res.data.total * 1;
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.getPolite();
    },
    activityUrl(arr) {
      let arr1 = [...arr];
      arr1.forEach((item, index) => {
        let mesUrl = "";
        // 二维码进小程序
        let xcxUrl = this.$commonUrl(); // 正式
        let options = {
          activityId: item.id,
          venderId: this.$store.state.loginUserInfo.venderId,
          activityType: item.activityType || item.type,
          id: item.id,
          index: item.type == 12 ? 2 : 1,
        };
        let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%2C%22index%22%3A${options.index}%7D`;
        // 1：日历签到
        if (item.activityType == 1) {
          item.idUrl = xcxUrl + "pages/interactTask/signPolite/signPolite.html%3fitem%3d" + params1;
        }
        // 2：浏览礼品有礼
        // if (item.activityType == 2) {
        //   item.idUrl = ""
        // }
        // 3：每日抢好礼
        if (item.activityType == 3) {
          item.idUrl = xcxUrl + "pages/interactTask/robGoodPresent/robGoodPresent.html%3fitem%3d" + params1;
        }
        // 4：关注店铺有礼
        if (item.activityType == 4) {
          item.idUrl = xcxUrl + "pages/interactTask/attentionShop/attentionShop.html%3fitem%3d" + params1;
        }
        //  5：邀请开卡
        if (item.activityType == 5) {
          item.idUrl = xcxUrl + "pages/interactTask/inviteCard/inviteCard.html%3fitem%3d" + params1;
        }
        //  6：邀请关注店铺
        if (item.activityType == 6) {
          item.idUrl = xcxUrl + "pages/interactTask/invite/invite.html%3fitem%3d" + params1;
        }
        // 7：完善信息有礼
        if (item.activityType == 7) {
          item.idUrl = xcxUrl + "pages/interactTask/perfect_information/perfect_information.html%3fitem%3d" + params1;
        }
        //  8：幸运抽奖
        if (item.activityType == 8) {
          item.idUrl = xcxUrl + "pages/interactPark/bigTurntable/bigTurntable.html%3fitem%3d" + params1;
        }
        //  京获客1.2 下单复购首单
        if (item.activityType == 16 || item.activityType == 17 || item.activityType == 18) {
          item.idUrl = xcxUrl + "pages/interactTask/ordergift/ordergift.html%3fitem%3d" + params1;
        }
        //  19：下单抽奖
        if (item.activityType == 19) {
          item.idUrl = xcxUrl + "pages/interactPark/placeOrder/placeOrder.html%3fitem%3d" + params1;
        }
        //  京获客1.3 评价有礼
        if (item.activityType == 20) {
          item.idUrl = xcxUrl + "pages/interactTask/evaluation_gift/evaluation_gift.html%3fitem%3d" + params1;
        }
        //  京获客1.3 裂变神券
        if (item.activityType == 21) {
          item.idUrl = xcxUrl + "pages/interactTask/groupCoupon/groupCoupon.html%3fitem%3d" + params1;
        }
        //  京获客1.3 红包雨
        if (item.activityType == 22) {
          item.idUrl = xcxUrl + "pages/interactTask/redPacketRain/redPacketRain.html%3fitem%3d" + params1;
        }
        //  京获客1.4 疯狂抓娃娃
        if (item.activityType == 23) {
          item.idUrl = xcxUrl + "pages/gameCore/catchDoll/catchDoll.html%3fitem%3d" + params1;
        }
        //  京获客1.4 大家来找茬
        if (item.activityType == 24) {
          item.idUrl = xcxUrl + "pages/gameCore/seekDistinct/seekDistinct.html%3fitem%3d" + params1;
        }

        //  预售有礼
        if (item.activityType == 27) {
          item.idUrl = xcxUrl + "pages/interactTask/preGift/preGift.html%3fitem%3d" + params1;
        }
        //  预售抽奖
        if (item.activityType == 28) {
          item.idUrl = xcxUrl + "pages/interactTask/prePrize/prePrize.html%3fitem%3d" + params1;
        }
        //  超级裂变
        if (item.activityType == 31) {
          item.idUrl = xcxUrl + "pages/interactTask/superCoupon/superCoupon.html%3fitem%3d" + params1;
        }

        //  京豆、e卡
        if (item.activityType == 29 || item.activityType == 30) {
          item.idUrl = xcxUrl + "pages/integralStore/conversionDou/conversionDou.html%3fitem%3d" + params1;
        }
       //  红包
        if (item.activityType == 38) {
          item.idUrl = xcxUrl +"pages/integralStore/exchangeHb/exchangeHb.html%3fitem%3d" + params1;
        }


        if (item.activityType == 9) {
          item.idUrl = xcxUrl + "pages/integralStore/exchange/exchange.html%3fitem%3d" + params1;
        }
        if (item.activityType == 10) {
          item.idUrl = xcxUrl + "pages/integralStore/discount/discount.html%3fitem%3d" + params1;
        }

        if (item.type == 12) {
          item.idUrl = xcxUrl + "pages/integralStore/discountCoupon/discountCoupon.html%3fitem%3d" + params1;
        }
        if (item.type == 11) {
          item.idUrl = xcxUrl + "pages/integralStore/discountCoupon/discountCoupon.html%3fitem%3d" + params1;
        }
        if (item.activityType == 13) {
          item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
        }
        if (item.activityType == 31) {
          item.idUrl = xcxUrl + "pages/interactTask/superCoupon/superCoupon.html%3fitem%3d" + params1;
        }
        if (item.activityType == 36) {
          item.idUrl = xcxUrl + "pages/interactTask/orderRisk/orderRisk.html%3fitem%3d" + params1;
        }
        if (item.activityType == 14) {
          // item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
          item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
        }
      });

      return arr1;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
